import { datePart } from './honoraryMembership';
export interface MembershipPeriod {
  eintritt?: string | null;
  austritt_am?: string | null;
  geloescht_am?: string | null;
  geloescht?: number;
}
export const membershipEnd = (member: MembershipPeriod) => datePart(member.geloescht_am || member.austritt_am);
export function membershipInYear(member: MembershipPeriod, year: number): boolean {
  const start = datePart(member.eintritt), end = membershipEnd(member);
  return !!start && start <= `${year}-12-31` && (!end || end >= `${year}-01-01`);
}
export function mayRecordConsumption(member: MembershipPeriod, period?: string | null): boolean {
  const day = datePart(period), end = membershipEnd(member);
  if (!day) return !member.geloescht && !end;
  return (!end || day <= end) && (!member.geloescht || !!end);
}
export const membershipStatus = (member: MembershipPeriod) => member.geloescht
  ? member.austritt_am ? 'Ausgetreten' : 'Archiviert'
  : member.austritt_am ? 'Gekündigt' : 'Mitglied';
